"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
const common_1 = require("@angular/common");
const forms_1 = require("@angular/forms");
const core_1 = require("@angular/core");
const ng2_dragula_1 = require("ng2-dragula");
const idm_ng_controls_1 = require("@synisys/idm-ng-controls");
const sis_bar_chart_control_component_1 = require("./chart/bar-chart/sis-bar-chart-control.component");
const sis_column_chart_control_component_1 = require("./chart/column-chart/sis-column-chart-control.component");
const sis_pie_chart_control_component_1 = require("./chart/pie-chart/sis-pie-chart-control.component");
const material_module_1 = require("./material.module");
const sis_speedometer_chart_control_component_1 = require("./chart/speedometer-chart/sis-speedometer-chart-control.component");
const idm_entity_search_client_js_1 = require("@synisys/idm-entity-search-client-js");
const idm_filtering_controls_1 = require("@synisys/idm-filtering-controls");
const reporting_filter_module_1 = require("./reporting-filter/reporting-filter.module");
const clickOutside_directive_1 = require("./chart/shared/clickOutside.directive");
const router_1 = require("@angular/router");
const pipe_module_1 = require("../shared/pipe.module");
const serpentine_timeline_control_component_1 = require("./chart/serpentine-timeline/serpentine-timeline-control.component");
const area_timeline_control_component_1 = require("./chart/area-timeline/area-timeline-control.component");
const sis_radar_chart_control_component_1 = require("./chart/radar-chart/sis-radar-chart-control.component");
const sis_line_chart_control_component_1 = require("./chart/line-chart/sis-line-chart-control.component");
const sis_combination_chart_control_component_1 = require("./chart/combination-chart/sis-combination-chart-control.component");
const sis_scorecard_chart_control_component_1 = require("./chart/scorecard/sis-scorecard-chart-control.component");
let ReportingControlsModule = class ReportingControlsModule {
};
ReportingControlsModule = __decorate([
    core_1.NgModule({
        imports: [
            common_1.CommonModule,
            forms_1.FormsModule,
            ng2_dragula_1.DragulaModule,
            idm_ng_controls_1.ControlsModule,
            material_module_1.MaterialModule,
            forms_1.ReactiveFormsModule,
            idm_entity_search_client_js_1.EntitySearchModule,
            idm_filtering_controls_1.FilteringControlsModule,
            reporting_filter_module_1.ReportingFilterModule,
            router_1.RouterModule,
            pipe_module_1.PipeModule
        ],
        declarations: [
            sis_pie_chart_control_component_1.PieChartControlComponent,
            sis_speedometer_chart_control_component_1.SpeedometerChartControlComponent,
            clickOutside_directive_1.ClickOutsideDirective,
            serpentine_timeline_control_component_1.SerpentineTimelineControlComponent,
            area_timeline_control_component_1.AreaTimelineControlComponent,
            sis_radar_chart_control_component_1.RadarChartControlComponent,
            sis_line_chart_control_component_1.LineChartControlComponent,
            sis_combination_chart_control_component_1.CombinationChartControlComponent,
            sis_scorecard_chart_control_component_1.ScorecardChartControlComponent,
            sis_bar_chart_control_component_1.BarChartControlComponent,
            sis_column_chart_control_component_1.ColumnChartControlComponent
        ],
        exports: [
            clickOutside_directive_1.ClickOutsideDirective,
            pipe_module_1.PipeModule,
            reporting_filter_module_1.ReportingFilterModule,
            sis_pie_chart_control_component_1.PieChartControlComponent,
            sis_speedometer_chart_control_component_1.SpeedometerChartControlComponent,
            serpentine_timeline_control_component_1.SerpentineTimelineControlComponent,
            area_timeline_control_component_1.AreaTimelineControlComponent,
            sis_radar_chart_control_component_1.RadarChartControlComponent,
            sis_line_chart_control_component_1.LineChartControlComponent,
            sis_combination_chart_control_component_1.CombinationChartControlComponent,
            sis_scorecard_chart_control_component_1.ScorecardChartControlComponent,
            sis_bar_chart_control_component_1.BarChartControlComponent,
            sis_column_chart_control_component_1.ColumnChartControlComponent
        ]
    })
], ReportingControlsModule);
exports.ReportingControlsModule = ReportingControlsModule;
__export(require("./chart/shared/index"));
//# sourceMappingURL=reporting-controls.module.js.map